<template>
    <ModalDialogContainer ref="modalContainer" v-model:display="displayStatus" @keydown="escapeToClose">
        <div class="modal-dialog modal-md" role="document" @click="stopPropagationEvent">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title">{{ $t("Recording Permissions") }}</div>
                    <button type="button" class="btn-close" :title="$t('Close')" @click="deny"></button>
                </div>
                <div class="modal-body">
                    <label>{{ $t("The call will start recording.") }}</label>
                    <br><br>
                    <label>{{ $t("Please confirm your permission. In case you don´t accept, you will be out of the call.") }}</label>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary"  @click="accept"><i class="fas fa-check"/> {{ $t("Accept") }}</button>
                    <button type="button" class="btn btn-cancel" @click="deny"><i class="fa-solid fa-xmark"/>{{ $t("Deny") }}</button>
                </div>
            </div>
        </div>
    </ModalDialogContainer>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useVModel } from "@/utils/v-model";

export default defineComponent({
    name: "RecordingModal",
    emits: ["update:display", "confirm", "deny"],
    props: {
        display: Boolean,
    },
    setup(props) {
        return {
            displayStatus: useVModel(props, "display"),
        };
    },
    methods: {
        close: function () {
            this.displayStatus = false;
        },

        accept: function() {
            this.$emit("confirm"); 
            this.close(); 
        },

        deny: function() {
            this.$emit("deny"); 
            this.close(); 
        },

        escapeToClose: function (event) {
            if (event.key === "Escape") {
                this.deny();
                this.displayStatus = false;
            }
        },

        stopPropagationEvent: function (e) {
            e.stopPropagation();
        },
    },
    mounted: function () {
        if (this.display) {
            this.$autoFocus();
        }
    },
    watch: {
        display: function () {
            if (this.display) {
                this.$autoFocus();
            }
        },
    },
});
</script>

<style scoped>
/* @import "@/style/modals/delete-version.css"; */
</style>
